import { object, boolean, array, string } from 'yup';
import { TFunction } from 'i18next';

import { isFilledManagementCompanySelection } from './managementCompanies';

export function makeClientStatementSchema(t: TFunction) {
  return object().shape({
    a: boolean().oneOf([true], t('form.required')).required(t('form.required')),
    b: array(string())
      .required(t('form.required'))
      .min(1, t('form.required'))
      .test('managementCompanyName', t('form.required'), (selections) => {
        if (!selections) {
          return false;
        }
        return selections.every((selection) => isFilledManagementCompanySelection(selection));
      }),
  });
}
